import yup from "../../../utils/yup-extended";
import {tierPricingValidationSchemaFields} from "../tier-pricing-schema";

export const editSubscriptionBasicFormValidationSchema = yup.object().shape({
  name: yup.string().trim().required("Name is required"),
  description: yup.string().trim(),
  hideFromProfile: yup.bool().default(false),
  requestCustomerPhoneNumber: yup.bool().default(false),
  isUrlRedirect: yup.bool().default(false),
  limitUnitsPerTransaction: yup.bool().default(false).optional(),
  url_redirect: yup
    .string()
    .trim()
    .nullable()
    .when("isUrlRedirect", {
      is: (isUrlRedirect: boolean) => isUrlRedirect,
      then: (schema) => schema.required("Redirect URL is required").urlWithEmoji().trim(),
      otherwise: (schema) => schema.notRequired(),
    }),
  enable_currency_conversion: yup.bool().optional(),
  selected_currencies: yup.array().of(yup.string()).optional(),
  tiers: yup.array().of(
    yup.object().shape({
      apiTierId: yup.number().optional(),
      tierName: yup
        .string()
        .trim()
        .required("Enter a name for this tier so you have at least one complete tier"),
      ...tierPricingValidationSchemaFields,
      billingFrequency: yup.string().when("priceType", {
        is: "free",
        then: (schema) => schema.notRequired(),
        otherwise: (schema) =>
          schema.oneOf(["daily", "weekly", "monthly", "yearly"]).required(),
      }),
      billingCount: yup.string().when("priceType", {
        is: "free",
        then: (schema) => schema.notRequired(),
        otherwise: (schema) => schema.oneOf(["custom", "until_cancel"]).required(),
      }),
      billingCycles: yup
        .number()
        .transform((value, originalValue) => (originalValue === "" ? undefined : value))
        .when(["priceType", "billingCount"], {
          is: (priceType: string, billingCount: string) =>
            priceType !== "free" && billingCount === "custom",
          then: (schema) =>
            schema
              .typeError("Please enter the number of billing cycles")
              .integer("Billing cycles must be a whole number")
              .min(1, "Billing cycles must be at least 1")
              .required("Please enter the number of billing cycles"),
          otherwise: (schema) => schema.notRequired(),
        }),
      featuresEnabled: yup.bool().default(false),
      features: yup.array().when("featuresEnabled", {
        is: (featuresEnabled?: boolean) => featuresEnabled === true,
        then: (schema) =>
          schema.test(
            "at-least-one-feature",
            "Please enter at least one feature",
            (rows) => {
              const list = rows ?? [];
              return list.some(
                (r: {value?: string}) =>
                  typeof r?.value === "string" && r.value.trim().length > 0
              );
            }
          ),
        otherwise: (schema) => schema.notRequired(),
      }),
      newFeatureInput: yup.string().when("featuresEnabled", {
        is: (featuresEnabled?: boolean) => featuresEnabled === true,
        then: (schema) => schema.optional(),
        otherwise: (schema) => schema.notRequired(),
      }),
    })
  ),
});
